export default __webpack_public_path__ + "static/media/members-choice-medal.ea3a84fe.svg";